import * as data from '../app-version.json'

export const appVersion = data.version
